// src/charts/forecastChart/config.js

/**
 * Configuration constants for the forecast chart visualization.
 */
export const GRAPH_CONFIG = Object.freeze({
  svgHeight: 50, // SVG viewBox height (pixels)
  xStep: 25, // Horizontal spacing between temperature data points
});
